import React, { Component } from 'react'
import { HashRouter, Link } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setDeviceConfigFailed, setMobileTVPage, setFailScreen, openSMSWidget, setOpenProfileImage } from '../../action/action'
import { connect } from 'react-redux'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setOpenDemoCamera, setGoHome, setLoader, setLoginRequired, setDNDon, setMURon } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { guestDetails, sendAnalytics } from "../../action/homeAction"
import { withTranslation } from 'react-i18next';
import { sendAcCommand } from '../../action/roomControlAction'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'
import { isUserLoggedin } from '../../layout2.0/components/hotelSelector/hotelSelector'
class SingleSqureSmall extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetData: {}
        }
    }

    componentDidMount() {
        if (this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }
    componentDidUpdate(preProb) {
        if (preProb.widgetList !== this.props.widgetList && this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }
    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if(!room){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }

            }
            if (widget.path === "/happy") {
                if(this.props.survey.needsLogin)
                if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        console.log()
        return (
            <div class="widgets margin-0">
                <div class="row">
                    <div class="col col-2 flex-nowrap">
                        <Link
                            exact to={this.state.widgetData.path ? this.state.widgetData.path : "/"}
                            onClick={() => { this.onWidgetClick(this.state.widgetData) }}
                            class={`tile-sm thumbnails tile-container no-img-thumb ${this.state.widgetData.widgetType == "Guest Details" ? `widget-info  ${isUserLoggedin()?"_logged-in_":"_logged-out_"}` : ""}`}
                            style={this.state.widgetData.compImage ? {
                                backgroundImage: `url('${this.state.widgetData.compImage}')`,
                                backgroundSize: "cover",
                                backgroundPositionX: "center",
                                backgroundPositionY: "top"
                            } : {}}>
                            <div class="thumb-text">
                                <p class="heading" dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetTitle ? this.state.widgetData.widgetTitle : ""}} ></p>
                                <p className="label" dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetDesc ? this.state.widgetData.widgetDesc : ""}} ></p>
                            </div>
                        </Link>
                        {/* <a class="tile-sm thumbnails tile-container no-img-thumb"
                            style={{
                                display: "none"
                            }}>
                            <div class="thumb-text">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.27 57.72"><title>Door Cam</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M76.27,0H2A2,2,0,0,0,0,2V14.15a5,5,0,0,0,5,5H6.34V32.8A24.92,24.92,0,0,0,31.25,57.72H47A24.92,24.92,0,0,0,71.94,32.8V19.15h1.33a5,5,0,0,0,5-5V2A2,2,0,0,0,76.27,0ZM39.14,44.49A12.82,12.82,0,1,1,52,31.68,12.81,12.81,0,0,1,39.14,44.49Zm20.66-19a1.72,1.72,0,1,1,1.72-1.72A1.71,1.71,0,0,1,59.8,25.44Z" /><path class="cls-1" d="M39.14,22.34a9.34,9.34,0,1,0,9.34,9.34A9.34,9.34,0,0,0,39.14,22.34Zm.34,6.52c-2.82.23-2.72,2.67-3.48,3.52s-2.72.47-2.72.47a2.29,2.29,0,0,1-.84-2.35c1.22-3.38,5-5.06,5-5.06,1.77-1.07,3,.93,3,.93A2.38,2.38,0,0,1,39.48,28.86Z" /></g></g></svg>
                                <p>Door Camera</p>
                            </div>
                        </a> */}
                    </div>
                </div>
            </div>
        )
    }
}

SingleSqureSmall.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        setDNDon,
        setMURon,
        sendAcCommand,
        closeOrderPopUp,
        setHcommerceWidget,
        setMobileTVPage,
        guestDetails,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        setOpenExternalLinkInSameTab
    }
)(withTranslation('translations')(SingleSqureSmall));